import React from 'react';
import { useSelector } from 'react-redux';

import useWizardJump from '@swf/core/hooks/useWizardJump';
import { select } from '@swf/core/store';

import { getRmfRequiredPath } from '../../../utils/cashier';
import Prompt from '../../Prompt/Prompt';

import { TXTWCL_Continue, TXTWCL_Just_a_moment_1 } from './RMFRequired.messages.json';
import { messageText } from './RMFRequired.scss';

interface Props {
  onClose(): void;
  message: React.ReactNode;
}

const RMFRequired: React.FC<Props> = ({ onClose, message }) => {
  const wizardJump = useWizardJump();
  const isEmbedded = useSelector(select.device.isEmbedded);
  const site = useSelector(select.cms.getSiteId);
  const country = useSelector(select.country.getCountry);
  const path = getRmfRequiredPath(site, country);

  const jumpToRMF = () => {
    if (isEmbedded) {
      window.starsweb?.app.openRmf?.();
      return;
    }
    if (window.location.pathname === '/signup') {
      wizardJump.jumpBack(path);
    } else {
      wizardJump.jumpForward(path);
    }
  };
  return (
    <Prompt
      onClose={onClose}
      variant="info"
      title={{ translation: TXTWCL_Just_a_moment_1 }}
      primaryButton={{
        translation: TXTWCL_Continue
      }}
      onPrimaryButtonClick={jumpToRMF}
    >
      <div className={messageText}>{message}</div>
    </Prompt>
  );
};

export default RMFRequired;
